import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import pageContext from '@bingads-webui-static-legacy/page-context';

export function load(campaignId, adgroupId, typesToLoad, schema = {}) {
  let filterString = '';
  let schemaName = schema.name || (adgroupId ? 'AdGroupCriterion' : 'CampaignCriterion');

  for (let i = 0; i < typesToLoad.length; i++) {
    filterString += `isof(Criterion,'Model.${typesToLoad[i]}')`;

    if (i !== typesToLoad.length - 1) {
      filterString += ' or ';
    }
  }

  let entitySet = adgroupId ?
    edmCampaign.currentAccount.Campaigns.$withKey(Number(campaignId)).AdGroups.$withKey(Number(adgroupId)) :
    edmCampaign.currentAccount.Campaigns.$withKey(Number(campaignId));

  entitySet = entitySet[`${schemaName}s`][`Model.${schemaName}`];

  return jsdata[schemaName].findAll(
    {query: {$filter: filterString}},
    {
      entitySet,
      cacheResponse: false,
      bypassCache: true,
      headers: {
        lcid: pageContext.CultureLcid,
      },
    }
  );
}
